import R from "ramda";

export default {
  fetch(state, {recipes, lines, ingredients, blockTypes}) {
    state.ingredients = ingredients;
    state.lines = lines;
    state.recipes = recipes;
    state.blockTypes = blockTypes;
  },
  set(state, payload) {
    return R.mapObjIndexed((val, key) => {
      state[key] = val;
    }, payload)
  }
}
